import React, {Fragment} from "react";
import { zl } from "../../../functions/utilities.js";
import { translate, rodzaj_rozliczenia } from "../../../functions/dictionary.js";
import { podstawa, zaokr } from '../../../functions/utilities.js';

const MieszkaniecWydrukStawki = props => {

    const { tablicaCzynszeAkt, stawkiOst } = props;
    let i = 1;

    const tabela = (stawkiOst) => {
        const elements = [];
        
        if (stawkiOst) {
            const hasOwn = Object.prototype.hasOwnProperty; 

            for (const key in stawkiOst) {
                if (tablicaCzynszeAkt && Object.prototype.hasOwnProperty.call(tablicaCzynszeAkt, key) && hasOwn.call(stawkiOst, key) && !key.startsWith('czy_') && !key.endsWith('_rodzaj')) {
                    const rodzajKey = `${key}_rodzaj`;
                    const czyKey = `czy_${key}`;
                    const cena = stawkiOst[key];
                    const rodzaj = stawkiOst[rodzajKey];
                    const czyUwzgledniany = stawkiOst[czyKey] && !isNaN(tablicaCzynszeAkt[key]);
                    
                    const podstawa_ = rodzaj_rozliczenia(rodzaj, key) == "opłata stała" ? 1 :  podstawa(tablicaCzynszeAkt, key);

                    if (czyUwzgledniany && cena > 0 && tablicaCzynszeAkt[key] > 0) {
                        elements.push(
                            <tr key={key}>
                                <td 
                                    style={{
                                        borderLeft: '1px solid black', 
                                        borderRight: '1px solid black',
                                        padding: '1mm 2mm',
                                        textAlign: 'center',
                                    }}
                                >    
                                    {i++}                                     
                                </td>
                                <td 
                                    style={{
                                        borderLeft: '1px solid black', 
                                        borderRight: '1px solid black',
                                        padding: '1mm 2mm',
                                    }}
                                >
                                    {translate(key)}                        
                                </td>
                                <td 
                                    style={{
                                        borderLeft: '1px solid black', 
                                        borderRight: '1px solid black',
                                        padding: '1mm 2mm',
                                        textAlign: 'center',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    {rodzaj_rozliczenia(rodzaj, key)}       
                                </td>
                                <td 
                                    style={{
                                        borderLeft: '1px solid black', 
                                        borderRight: '1px solid black',
                                        padding: '1mm 2mm',
                                        textAlign: 'center',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    { isNaN(podstawa_) ? 0 : zaokr(podstawa_, 2) }
                                </td>
                                <td 
                                    style={{
                                        borderLeft: '1px solid black', 
                                        borderRight: '1px solid black',
                                        padding: '1mm 2mm',
                                        textAlign: 'center',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    {zl(cena)}    
                                </td>
                                <td
                                    style={{
                                        borderLeft: '1px solid black', 
                                        borderRight: '1px solid black',
                                        padding: '1mm 2mm',
                                        textAlign: 'right',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    {zl(tablicaCzynszeAkt[key])}            
                                </td>
                            </tr>
                        );
                    }
                }
            }
            return elements;
        } else return ""
    };

    return (
        <Fragment>
            { tabela(stawkiOst) }
        </Fragment>
    )
}

export default MieszkaniecWydrukStawki;